define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/getProto.js
// module id = 494
// module chunks = 0